import {sentinelMw} from '../api';

export default {
    api: sentinelMw,
    url: 'give-ups',
    useCache: false,
    parseResponse: ({data}) => data,
    defaultValue: []
};
